import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowFitTopLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.999 2.499a1.5 1.5 0 0 1 1.5-1.5h5.518a.5.5 0 1 1 0 1h-5.31L10 9.293V6.156h1v4.845H6.155a.5.5 0 0 1 0-1h3.139L1.999 2.706v5.311a.5.5 0 1 1-1 0zm9.502 3.656H10a.5.5 0 0 1 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopLeft12);
